<template>
    <li class="nav-title">
        <!--    <li class="nav-title"  @mouseenter="hoverOpen">-->
        <p @mouseenter="handleOpening" @click="mobileIsOpen = true" >
            <slot name="nav-title"/>
        </p>

        <ul v-if="isMobile" class="hidden-sub-nav" :class="{ 'visible-sub-nav': mobileIsOpen && global }">
            <p class="button-back" @click="mobileIsOpen = false">
                <slot name="button-back"/>
            </p>
            <slot name="hidden-sub-nav"/>
        </ul>

        <ul v-if="!isMobile" class="hidden-sub-nav" @mouseleave="leave" :class="{ 'visible-sub-nav': isOpen }">
            <p class="button-back" @click="mobileIsOpen = false">
                <slot name="button-back"/>
            </p>
            <slot name="hidden-sub-nav"/>
        </ul>
    </li>


</template>

<script>
import SearchBar from "./SearchBar";
import {debounce} from "lodash";
import width from "../../helpers/width";


export default {
    mixins: [width],
    components: {SearchBar},
    props: {
        global: Boolean,
        currentSlots: String,
        activeSlot: String,

    },
    data() {
        return {
            mobileIsOpen: false
        }
    },
    computed: {
        isOpen() {
                return this.currentSlots ===  this.activeSlot
        }
    },
    methods: {
        handleOpening(){
            this.$emit('setActiveSlot', this.currentSlots)
        },
        handleIsOpen() {
            this.isOpen = false
        },
        leave(){
            this.$emit('setActiveSlot', null)
        },
        debouncedHandleOpen() {
            debounce(this.handleIsOpen, 300)
        }
    },
    mounted() {
    }
}
</script>

<style scoped>

</style>
